'use client';

import React from 'react';
import Script from 'next/script';
import { usePathname } from 'next/navigation';

const ADSENSE_CLIENT = process.env.NEXT_PUBLIC_ADSENSE_CLIENT;

/**
 * Loads the AdSense script — except on the children's section.
 *
 * Serving behaviourally-targeted advertising on a child-directed surface
 * engages COPPA in the US and GDPR-K / the Age Appropriate Design Code in
 * Europe. `/kids/**` is unambiguously child-directed, so the loader simply
 * does not run there.
 *
 * Known limitation: Next keeps an already-loaded script in the document, so a
 * *client-side* navigation from, say, `/typing-test` to `/kids` arrives with
 * the script already present. This blocks the common cases — a bookmark, a
 * search result, a shared link, a hard refresh — but full isolation would need
 * the kids section served from its own document (a separate deployment, or a
 * middleware-driven hard navigation). Worth doing before monetising the site
 * more aggressively.
 */
export default function AdSenseLoader() {
  const pathname = usePathname();

  if (!ADSENSE_CLIENT) return null;
  if (pathname?.startsWith('/kids')) return null;

  return (
    <Script
      async
      src={`https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADSENSE_CLIENT}`}
      crossOrigin="anonymous"
      strategy="afterInteractive"
    />
  );
}
